import React from 'react';
import { Group, Line, Text } from 'react-konva';
import { BOTTOM_OFFSET, LEFT_OFFSET, RIGHT_OFFSET, TOP_OFFSET, } from './constants';
import { GroundGeometry } from 'types/webPlayer';
import { GroundType } from 'models/ground';

export default function GroundDebug( props: {
  data: GroundType,
  geometry: GroundGeometry
} ) {
  const {data, geometry} = props;

  const {
    vertex: {vertexA, vertexC, vertexB, vertexD},
  } = geometry;

  const {
    vertexAX, vertexAY, vertexBX, vertexBY, vertexCX, vertexCY, vertexDX, vertexDY,
  } = data;

  const groundPoints = [
    ...[vertexA.x, vertexA.y],
    ...vertexB ? [vertexB.x, vertexB.y] : [],
    ...[vertexC.x, vertexC.y],
    ...vertexD ? [vertexD.x, vertexD.y] : [],
  ];

  return (
    <Group>
      <Text
        x={vertexA.x + 20}
        y={vertexA.y + 20}
        fontSize={14}
        text={`A: ${vertexAX.value} x ${vertexAY.value}`}
        fill="#000"
      />
      <Text
        x={vertexC.x - 150}
        y={vertexC.y - 40}
        fontSize={14}
        text={`C: ${vertexCX.value} x ${vertexCY.value}`}
        fill="#000"
        align="right"
      />

      {
        vertexB && (
          <Text
            x={vertexB.x + 20}
            y={vertexB.y - 40}
            fontSize={14}
            text={`B: ${vertexBX.value} x ${vertexBY.value}`}
            fill="#000"
          />
        )
      }

      {
        vertexD && (
          <Text
            align="right"
            x={vertexD.x - 150}
            y={vertexD.y + 20}
            fontSize={14}
            text={`D: ${vertexDX.value} x ${vertexDY.value}`}
            fill="#000"
          />
        )
      }

      <Line
        points={groundPoints}
        stroke="#e20"
        strokeWidth={2}
      />
    </Group>
  );
}
